
//获取指定的cookie; 没有则返回空字符串
export let getCookie = function (name = 'token') {
    let cookieArr = document.cookie.split('; ')
    for (let x = 0; x < cookieArr.length; x++) {
        let arr = cookieArr[x].split('=')
        if (arr[0] == name) return arr[1] 
    }
    return '';
}

//删除指定的cookie
export let removeCookie = function (name = 'token') {
    let date = new Date()
    date.setTime(date.getTime() - 10000)
    document.cookie = name + '=v; expires=' + date.toGMTString(); 
}

export let getTime = function (date, type) {
    let nowDate = new Date(date)
    if (type == 'getTime') {
        return nowDate.getTime()
    }
}


// export default {
//     getCookie,
//     removeCookie
// }